var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M26.46 19.2578C24.5467 19.2578 22.6956 18.9467 20.9689 18.3867C20.4244 18.2 19.8178 18.34 19.3978 18.76L16.9556 21.8244C12.5533 19.7244 8.43111 15.7578 6.23778 11.2L9.27111 8.61778C9.69111 8.18222 9.81556 7.57556 9.64444 7.03111C9.06889 5.30444 8.77333 3.45333 8.77333 1.54C8.77333 0.7 8.07333 0 7.23333 0H1.85111C1.01111 0 0 0.373333 0 1.54C0 15.9911 12.0244 28 26.46 28C27.5644 28 28 27.02 28 26.1644V20.7978C28 19.9578 27.3 19.2578 26.46 19.2578Z","fill":"#38B2B1"}));
}

Phone.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = Phone;

Phone.default = Phone;
